import React from "react";
import styled from "@emotion/styled";

export const RankTable = (props) => {
  const { data, title } = props;
  return (
    <>
      <Title>{title}</Title>
      <ContainerUl>
        {data.map(
          (item, index) =>
            item.rank <= 10 && (
              <Li isBG2={index % 2 === 0}>
                <RankText>คะแนนสะสม อันดับ {item.rank}</RankText>
                <Score>
                  {item.firstname} ({item.nickname})
                </Score>
              </Li>
            )
        )}
      </ContainerUl>
    </>
  );
};

const Title = styled.div`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 21px;
  margin-bottom: 8px;
  color: #4b5768;
`;

const ContainerUl = styled.ul`
  display: flex;
  list-style-type: none;
  flex-direction: column;
  width: 100%;
  padding: 0;
  margin: 0;
`;

const Li = styled.li`
  font-family: 'Noto Sans Thai', 'Noto Sans';
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin: 3px 0;
  padding: 0 5px;
  background: ${(props) => (props.isBG2 ? "#F7F8F9" : "#fff")};}; 
`;

const RankText = styled.div`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-size: 18px;
  color: #4b5768;
`;

const Score = styled.div`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-size: 18px;

  text-align: right;
  font-weight: 700;

  color: #4b5768;
`;
